import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

const ModalInput = ({
  title, form, onOkClick, onCancelClick, show
}) => (
  <Modal
    title={title}
    wrapClassName="bhp-modal-form bhp-vertical-centered"
    width={650}
    visible={show}
    closable={false}
    destroyOnClose
    okText="Add"
    onOk={onOkClick}
    onCancel={onCancelClick}
  >
    {form}
  </Modal>
);
ModalInput.propTypes = {
  form: PropTypes.object.isRequired,
  onOkClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string.isRequired
};

ModalInput.defaultProps = {
  show: false,
  onOkClick() {
  },
  onCancelClick() {
  }
};

export default ModalInput;
